import dayjs from 'dayjs';

export default values => {
    if (values.length) {
        return values.reduce(
            (accumulator, value) =>
                `${accumulator ? accumulator + ',' : ''} ${dayjs(value).format(
                    'DD/MM/YYYY HH:mm:ss'
                )}`,
            ''
        );
    }

    return '-';
};
